export let WixNamespace = /*#__PURE__*/function (WixNamespace) {
  WixNamespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
  WixNamespace["WIX"] = "WIX";
  WixNamespace["SHOUT_OUT"] = "SHOUT_OUT";
  WixNamespace["ALBUMS"] = "ALBUMS";
  WixNamespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
  WixNamespace["HOTELS"] = "HOTELS";
  WixNamespace["CLUBS"] = "CLUBS";
  WixNamespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
  WixNamespace["DEV_SITE"] = "DEV_SITE";
  WixNamespace["LOGOS"] = "LOGOS";
  WixNamespace["VIDEO_MAKER"] = "VIDEO_MAKER";
  WixNamespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
  WixNamespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
  WixNamespace["HTML_DRAFT"] = "HTML_DRAFT";
  WixNamespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
  WixNamespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
  WixNamespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
  WixNamespace["ANYWHERE"] = "ANYWHERE";
  WixNamespace["HEADLESS"] = "HEADLESS";
  WixNamespace["ACCOUNT_MASTER_CMS"] = "ACCOUNT_MASTER_CMS";
  WixNamespace["RISE"] = "RISE";
  WixNamespace["BRANDED_FIRST"] = "BRANDED_FIRST";
  WixNamespace["NOWNIA"] = "NOWNIA";
  WixNamespace["UGC_TEMPLATE"] = "UGC_TEMPLATE";
  WixNamespace["CODUX"] = "CODUX";
  WixNamespace["MEDIA_DESIGN_CREATOR"] = "MEDIA_DESIGN_CREATOR";
  return WixNamespace;
}({});
//# sourceMappingURL=WixNamespace.js.map